import * as $ from 'jquery';
import * as ko from 'knockout';

declare var DobryKantor: any;
declare var Hammer: any;

export class BannersComponent {
    numberOfBanners: number = 4;
    slideTime: number = 7000;
    index: ko.Observable<number>;
    bannerClass: ko.Computed<string>;
    timer: any;
    totalnaWyprzedazAktywna: boolean = false;

    executeTimer() {
        this.timer = setTimeout(() => {
            this.index(this.index() % this.numberOfBanners + 1);
            this.executeTimer();
        }, this.slideTime);
    }

    constructor() {
        this.index = ko.observable(1);

        this.bannerClass = ko.computed(() => {
            return "banner-" + this.index();
        });

        this.executeTimer();

        var hammertime = new Hammer($('#banner').get(0), {});
        hammertime.on('swiperight', ev => {
            this.switchBanner(this.index() % this.numberOfBanners + 1);
        });

        hammertime.on('swipeleft', ev => {
            let nextIndex = this.index() - 1;
            if (nextIndex == 0) {
                nextIndex = this.numberOfBanners;
            }

            this.switchBanner(nextIndex);
        });
    }

    isCurrentIndex(index: number) {
        return this.index() === index;
    }

    switchBanner = (index: number) => {
        clearTimeout(this.timer);
        this.index(index);
    }
}
